(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-career"] && !Shopify.designMode) return;
  try {
    
  (async() => {
      while(!window.hasOwnProperty("jQuery")) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      let offersExists = false;
      $('[data-offer2do]').each(function () {
        if (!offersExists) {
          $('#offersPositions').html('').addClass('accordion');
          offersExists = true;
        }
        let item = $(this).detach();
        item.appendTo('#offersPositions');
      });
      let offersCount = $('[data-offer2do]').length;
      if (offersCount>0) {
        if (offersCount<=9) {
          $('#offersPositions').prev().find('sup').text('0' + offersCount);
        } else {
          $('#offersPositions').prev().find('sup').text(offersCount);
        }
        $('#offersPositions').find('.accordion-item').removeClass('d-none');        
      }

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-mission"] && !Shopify.designMode) return;
  try {
    
  const canvas = document.getElementById("canvas");
  const c = canvas.getContext("2d");

  let w;
  let h;

  const setCanvasExtents = () => {
    w = document.body.clientWidth;
    h = document.body.clientHeight;
    canvas.width = Math.min(1600, w);
    canvas.height = Math.min(900, h);
  };

  setCanvasExtents();

  const crawl = document.getElementById("crawl");
  const crawlContent = document.getElementById("crawl-content");
  const crawlContentStyle = crawlContent.style;

  // start crawl at bottom of 3d plane
  let crawlPos = crawl.clientHeight;

  const makeStars = count => {
    const out = [];
    for (let i = 0; i < count; i++) {
      const s = {
        x: Math.random() * 1600 - 800,
        y: Math.random() * 900 - 450,
        z: Math.random() * 1000
      };
      out.push(s);
    }
    return out;
  };

  let stars = makeStars(2000);

  window.onresize = () => {
    setCanvasExtents();
  };

  const clear = () => {
    c.fillStyle = "black";
    c.fillRect(0, 0, canvas.width, canvas.height);
  };

  const putPixel = (x, y, brightness) => {
    const intensity = brightness * 255;
    const rgb = "rgb(" + intensity + "," + intensity + "," + intensity + ")";
    c.fillStyle = rgb;
    c.fillRect(x, y, 1, 1);
  };

  const moveStars = distance => {
    const count = stars.length;
    for (var i = 0; i < count; i++) {
      const s = stars[i];
      s.z -= distance;
      if (s.z <= 1) {
        s.z += 999;
      }
    }
  };

  const moveCrawl = distance => {
    crawlPos -= distance;
    crawlContentStyle.top = crawlPos + "px";

    // if we've scrolled all content past the top edge
    // of the plane, reposition content at bottom of plane
    if (crawlPos < -crawlContent.clientHeight) {
      crawlPos = crawl.clientHeight;
    }
  };

  const paintStars = () => {
    const cx = canvas.width / 2;
    const cy = canvas.height / 2;

    const count = stars.length;
    for (var i = 0; i < count; i++) {
      const star = stars[i];

      const x = cx + star.x / (star.z * 0.001);
      const y = cy + star.y / (star.z * 0.001);

      if (x < 0 || x >= w || y < 0 || y >= h) {
        continue;
      }

      const d = star.z / 1000.0;
      const b = 1 - d * d;

      putPixel(x, y, b);
    }
  };

  let prevTime;
  const init = time => {
    prevTime = time;
    requestAnimationFrame(tick);
  };

  const tick = time => {
    let elapsed = time - prevTime;
    prevTime = time;

    moveStars(elapsed * 0.02);

    // time-scale of crawl, increase factor to go faster
    moveCrawl(elapsed * 0.06);

    clear();
    paintStars();

    requestAnimationFrame(tick);
  };

  requestAnimationFrame(init);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  if (window.location.href.endsWith('/collections') || window.location.href.endsWith('/collections/')) {
    window.location.href = '/collections/frontpage';
  } 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-group_header"] && !Shopify.designMode) return;
  try {
    
  (async() => {
      while(!window.hasOwnProperty("jQuery")) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      $('body').addClass('transparent-menu white-menu');

      let footer_parent = $('footer').parent();
      $(footer_parent).css("z-index","3")

      // $('ul[data-pgh]').clone().insertBefore(footer_parent).addClass("go-to-page fixed-bottom").attr('id','nav').attr('data-component','sticky-observer');
      $('ul[data-pgh]').clone().appendTo('main').addClass("go-to-page fixed-bottom").attr('id','nav').attr('data-component','sticky-observer');

      $('body').trigger('initNavButtons');
      
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-header"] && !Shopify.designMode) return;
  try {
    
  (async() => {
      while(!window.hasOwnProperty("jQuery")) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      $('body').addClass('transparent-menu');

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-referral_header"]) return;
  try {
     
  (async() => {
      while(!window.hasOwnProperty("jQuery")) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      $('body').addClass('transparent-menu white-menu');

  })();

  } catch(e) { console.error(e); }
})();
})();
